/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const Newsletter = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 26 26">
      <path
        d="M20.5,0 L4.5,0 C3.67157288,0 3,0.671572875 3,1.5 L3,23.5 C3,24.3284271 3.67157288,25 4.5,25 L20.5,25 C21.3284271,25 22,24.3284271 22,23.5 L22,1.5 C22,0.671572875 21.3284271,0 20.5,0 Z M21,23.5 C21,23.7761424 20.7761424,24 20.5,24 L4.5,24 C4.22385763,24 4,23.7761424 4,23.5 L4,1.5 C4,1.22385763 4.22385763,1 4.5,1 L20.5,1 C20.7761424,1 21,1.22385763 21,1.5 L21,23.5 Z M6,6.5 C6,6.22385763 6.22385763,6 6.5,6 L13.5,6 C13.7761424,6 14,6.22385763 14,6.5 C14,6.77614237 13.7761424,7 13.5,7 L6.5,7 C6.22385763,7 6,6.77614237 6,6.5 Z M19,10.5 C19,10.7761424 18.7761424,11 18.5,11 L6.5,11 C6.22385763,11 6,10.7761424 6,10.5 C6,10.2238576 6.22385763,10 6.5,10 L18.5,10 C18.7761424,10 19,10.2238576 19,10.5 Z M19,14.5 C19,14.7761424 18.7761424,15 18.5,15 L6.5,15 C6.22385763,15 6,14.7761424 6,14.5 C6,14.2238576 6.22385763,14 6.5,14 L18.5,14 C18.7761424,14 19,14.2238576 19,14.5 Z M19,18.5 C19,18.7761424 18.7761424,19 18.5,19 L6.5,19 C6.22385763,19 6,18.7761424 6,18.5 C6,18.2238576 6.22385763,18 6.5,18 L18.5,18 C18.7761424,18 19,18.2238576 19,18.5 Z"
        id="path-1" />
    </BaseSvgIcon>
  )
}

export default Newsletter
